export default __webpack_public_path__ + "static/media/5.5d94bb04.jpg";